export * from './PriceLegalMentionsRepository';
export * from './isPriceExceptionLegalMentionsEnabled';
